import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { BaseComponent } from '@app/directives/base-component';

@Component({
    selector: 'app-card-account',
    templateUrl: './card-account.component.html',
    styleUrls: ['./card-account.component.scss'],
    standalone: false
})

export class CardAccountComponent extends BaseComponent implements OnInit {
  @Input() card: any;
  @Input() defaultPaymentId: string;
  @Output() onUpdate: EventEmitter<any> = new EventEmitter();

  constructor() { super(); }

  ngOnInit(){
    // console.log(this.card, this.defaultPaymentId)
  }
  onClickList(card){
    this.onUpdate.next(card)
  }
}
